module.exports = __webpack_public_path__ + "static/media/btnGooglePlay.64c46132.svg";